import React, { useState, useEffect } from "react";
import { useParams } from 'react-router-dom';
import "./Chat.css";
import { storage, auth, db } from "./firebase";
import ChatCard from "./ChatCard";
import ChatCardTwo from "./ChatCardTwo";

function ChatTasker() {
  const { requestId } = useParams();
    const [chats, setChat] = useState([]);
    const [serviceRequests, setServiceRequests] = useState([]);
    function GetUserUid() {
      const [uid, setUid] = useState(null);
      useEffect(() => {
        auth.onAuthStateChanged((user) => {
          if (user) {
            console.log("YESS", user);
            setUid(user.uid);
          }
        });
      }, []);
      return uid;
    }
    const uid = GetUserUid();
  
    function GetCurrentUser() {
      const [user, setUser] = useState(null);
      const [roomDetails, setRoomDetails] = useState([]);
  
      useEffect(() => {
        auth.onAuthStateChanged((user) => {
          if (user) {
            db.collection("ServiceProviders").doc(user.uid).get();
          } else {
            setUser(null);
          }
        });
      }, []);
      return user;
    }
    const user = GetCurrentUser();
useEffect(() => {
  if (uid) {
    db.collection("ServiceProviders")
.doc(uid) 
.collection("ServiceRequests")
.doc(requestId)
.onSnapshot((snapshot) => setServiceRequests(snapshot.data()));
    }
  }, [uid]);
  useEffect(() => {
    db.collection("chat")
    .where("tasId","==",uid)
    .onSnapshot((snapshot) =>
      setChat(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          tasId: doc.data().tasId,
          customerId: doc.data().customerId,
          message: doc.data().message,
          timestamp: doc.data().timestamp,
        }))
      )
    );
      
  }, [uid]);
   return (
    <div className="App">
     
    <div className="wrapper">
      <div className="content">
        <div className="header">
          <div className="img">
            <img src="" alt="" />
          </div>
          <div className="right">
            <div className="status" style={{marginLeft: '-90px'}}>Active Now</div>
          </div>
        </div>
        <div className="main">
        {chats?.map(({ id, tasId, customerId, message }) => (
              <ChatCard
                id={id}
                tasId={tasId}
                customerId={customerId}
                message={message}
              />
            ))}

          <div style={{marginTop: '-100px'}}>
            </div>
        </div>
        <div className="bottom">
          <div className="btm">
            <div className="input">
              <input
                type="text"
                onChange=""
                id="input"
                placeholder="Enter your message"
              />
            </div>
            <div className="btn">
              <button onClick="">
                <i className="fas fa-paper-plane"></i>Send
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  )
}

export default ChatTasker